import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateShopifyAuthzRequestMutationVariables = Types.Exact<{
  input: Types.CreateShopifyAuthzRequestInput;
}>;


export type CreateShopifyAuthzRequestMutation = { __typename?: 'RootMutationType', createShopifyAuthzRequest?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const CreateShopifyAuthzRequestDocument = gql`
    mutation createShopifyAuthzRequest($input: CreateShopifyAuthzRequestInput!) {
  createShopifyAuthzRequest(input: $input) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type CreateShopifyAuthzRequestMutationFn = Apollo.MutationFunction<CreateShopifyAuthzRequestMutation, CreateShopifyAuthzRequestMutationVariables>;

/**
 * __useCreateShopifyAuthzRequestMutation__
 *
 * To run a mutation, you first call `useCreateShopifyAuthzRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopifyAuthzRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShopifyAuthzRequestMutation, { data, loading, error }] = useCreateShopifyAuthzRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShopifyAuthzRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateShopifyAuthzRequestMutation, CreateShopifyAuthzRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShopifyAuthzRequestMutation, CreateShopifyAuthzRequestMutationVariables>(CreateShopifyAuthzRequestDocument, options);
      }
export type CreateShopifyAuthzRequestMutationHookResult = ReturnType<typeof useCreateShopifyAuthzRequestMutation>;
export type CreateShopifyAuthzRequestMutationResult = Apollo.MutationResult<CreateShopifyAuthzRequestMutation>;
export type CreateShopifyAuthzRequestMutationOptions = Apollo.BaseMutationOptions<CreateShopifyAuthzRequestMutation, CreateShopifyAuthzRequestMutationVariables>;